import axios from 'axios';
import { IMediaMonitoringData } from '../types/kato.types';
import { api } from './api';

const baseUrl = '/public';

export const getAvailableYears = (kato: number) => {
  return axios
    .get(`/api${baseUrl}/general/available-years`, {
      params: { kato },
    })
    .then((res) => res.data);
};

export const getGeneralInfo = (kato: number, year = 2026) => {
  return axios
    .get(`/api${baseUrl}/general`, {
      params: { kato, year },
    })
    .then((res) => res.data.data);
};

export const getImageById = (imageId: number) => {
  return `/api/public/image/load?imageId=${imageId}`;
};

export const getMMData = (kato: any): Promise<IMediaMonitoringData[]> => {
  return api
    .get(`/public/media-monitoring`, { params: { kato } })
    .then((res) => res.data.list);
};

export const getStatistics = (): Promise<any> => {
  return api.get(`${baseUrl}/kato/statistics`).then((res) => res.data.data);
};
